import { Outlet, createFileRoute } from '@tanstack/react-router';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import TokenEndCustomerIdProbe from '@/components/TokenEndCustomerIdProbe';
import { unitByIdQueryOptions } from '@/service/vpc/queryOptions';

export const Route = createFileRoute('/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId')({
  component: UnitsLayout,
  errorComponent: ErrorBoundary,
  loader: async (opts) => {
    const { endCustomerUnitId } = opts.params;

    if (!endCustomerUnitId) {
      return;
    }

    return opts.context.queryClient.ensureQueryData(unitByIdQueryOptions({ endCustomerUnitId }));
  },
});

function UnitsLayout() {
  return (
    <>
      <Outlet />
      <TokenEndCustomerIdProbe />
    </>
  );
}
